import React from 'react';

import copy from './i18n/sv.json';

function TrashIcon() {
  return (
    <svg
      aria-hidden="true"
      className="icon-button__icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h18" />
      <path d="M8 6V4h8v2" />
      <path d="M19 6l-1 14H6L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
    </svg>
  );
}

export default function ImageInputList({
  images,
  onAdd,
  onRemove,
  onTypeChange,
  onUrlChange,
  onFileChange
}) {
  const strings = copy.createSiteAdmin.imageInput;

  return (
    <div className="array-card">
      <div className="array-card-header">
        <div>
          <p className="array-card-title">{strings.title}</p>
          <p className="array-card-text">{strings.description}</p>
        </div>

        <button type="button" onClick={onAdd} className="button button--secondary">
          {strings.addMore}
        </button>
      </div>

      <div className="array-card-list">
        {images.length === 0 ? (
          <p className="array-card-text">{strings.noneAdded}</p>
        ) : null}

        {images.map((image, index) => (
          <div key={index} className="image-row">
            <select
              className="form-input image-row__type"
              value={image.type}
              onChange={(event) => onTypeChange(index, event.target.value)}
            >
              <option value="url">URL</option>
              <option value="base64">{strings.uploadOption}</option>
            </select>

            {image.type === 'url' ? (
              <input
                className="form-input"
                value={image.value}
                placeholder={strings.imagePlaceholder}
                onChange={(event) => onUrlChange(index, event.target.value)}
              />
            ) : (
              <div className="image-upload">
                <input
                  type="file"
                  accept="image/*"
                  className="form-input"
                  onChange={(event) => onFileChange(index, event.target.files?.[0] || null)}
                />
                <span className="image-upload__status">
                  {image.value ? strings.imageSelected : strings.noImageSelected}
                </span>
              </div>
            )}

            <button
              type="button"
              onClick={() => onRemove(index)}
              className="icon-button"
              aria-label={strings.removeRowPrefix + ' ' + (index + 1)}
            >
              <TrashIcon />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
